export default __webpack_public_path__ + "60018e78c62deaa96c828755b8e8062e.png";